export const handlePhoneNumberClick = (phoneNumber) => {
  window.location.href = `tel:${phoneNumber}`;
};
